import { ReactNode } from 'react';

import { Typography } from '@mui/material';

import styled from 'styled-components';

import { hexToRgbA } from '../utils';

interface RangeBlockProps {
  $width: number;
  $start: number;
}

const StyledRangeBlock = styled.div<RangeBlockProps>`
  position: absolute;
  left: ${({ $start }) => `${$start}%`};
  height: 30px;
  top: ${({ theme }) => theme.spacing(0.5)};
  width: ${({ $width }) => `${$width}%`};
  background: ${({ theme }) => hexToRgbA(theme.palette.neutrals.gray, 0.15)};
  border-left: 1px dashed ${({ theme }) => theme.palette.darkened.steel};
  border-right: 1px dashed ${({ theme }) => theme.palette.darkened.steel};
  display: flex;
  flex-direction: column;
  align-items: center;

  .left-label,
  .right-label {
    position: absolute;
    top: ${({ theme }) => theme.spacing(6)};
  }

  .left-label {
    left: 0;
    transform: translate(-100%, -100%);
    padding-right: ${({ theme }) => theme.spacing(1)};
  }

  .right-label {
    right: 0;
    transform: translate(100%, -100%);
    padding-left: ${({ theme }) => theme.spacing(1)};
  }
`;

export const RangeBlock = ({
  label,
  leftLabel,
  rightLabel,
  ...styleProps
}: {
  label: ReactNode;
  leftLabel?: ReactNode;
  rightLabel?: ReactNode;
} & RangeBlockProps) => {
  return (
    <StyledRangeBlock {...styleProps}>
      {leftLabel && (
        <Typography className="left-label" variant="body2.semibold">
          {leftLabel}
        </Typography>
      )}
      <Typography
        variant="body1"
        sx={{ textDecoration: 'underline' }}
        textTransform="uppercase"
        marginTop={6.5}
        width="100px"
      >
        {label}
      </Typography>
      {rightLabel && (
        <Typography className="right-label" variant="body2.semibold">
          {rightLabel}
        </Typography>
      )}
    </StyledRangeBlock>
  );
};
